import React, { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

export default function MentionsLegales() {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Mentions Légales | Elite Transfert</title>
        <meta name="description" content="Mentions légales d'Elite Transfert - Service VTC de luxe à Paris et en Île-de-France" />
        <link rel="canonical" href="https://elite-transfer.fr/mentions-legales" />
      </Helmet>
      
      <div ref={contentRef} className="min-h-screen bg-[#121212] text-white py-16 px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-4xl mx-auto"
        >
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-6 bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
              Mentions Légales
              <span className="block text-xl mt-2 bg-gradient-to-r from-yellow-500 to-yellow-600 bg-clip-text">
                Informations juridiques
              </span>
            </h1>
          </div>
          
          <div className="bg-gray-900/60 backdrop-blur-sm rounded-xl p-8 shadow-xl border border-gray-800">
            <motion.div 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2, duration: 0.5 }}
              className="space-y-8"
            >
              <div>
                <h2 className="text-2xl font-semibold text-yellow-500 mb-4">1. Informations légales</h2>
                <p className="text-gray-300 mb-4">
                  Ce site est édité par :
                  <br />
                  [bytebloom]
                  <br />
                  [77 rue jules michelet]
                  <br />
                  [97756136400018]
                  <br />
                  [Numéro de TVA intracommunautaire: Nan/]
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-semibold text-yellow-500 mb-4">2. Directeur de la publication</h2>
                <p className="text-gray-300 mb-4">
                  [Ammouri]
                  <br />
                  Contact : [contact@bytebloom.fr]
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-semibold text-yellow-500 mb-4">3. Hébergement</h2>
                <p className="text-gray-300 mb-4">
                  Ce site est hébergé par :
                  <br />
                  [Hostinger]
                  <br />
                  [ HOSTINGER INTERNATIONAL LTD, 61 Lordou Vironos Street, 6023 Larnaca, Chypre]
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-semibold text-yellow-500 mb-4">4. Propriété intellectuelle</h2>
                <p className="text-gray-300 mb-4">
                  L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-semibold text-yellow-500 mb-4">5. Responsabilité</h2>
                <p className="text-gray-300 mb-4">
                  La société [Nom de votre entreprise] s'efforce d'assurer au mieux de ses possibilités l'exactitude et la mise à jour des informations diffusées sur ce site, dont elle se réserve le droit de corriger, à tout moment et sans préavis, le contenu.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-semibold text-yellow-500 mb-4">6. Contact</h2>
                <p className="text-gray-300 mb-4">
                  Pour toute suggestion, information, réaction concernant ce site, n'hésitez pas à nous contacter :
                  <br />
                  Email : [contact@elitetransfert.com]
                </p>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </>
  );
}
